import { jsx as _jsx } from "react/jsx-runtime";
import { Box, freddyTheme as theme } from '@coolblue-development/freddy';
export const AdContainerBox = ({ mobileAspectRatio, desktopAspectRatio, hideBorder, children, }) => {
    return (_jsx(Box, { sx: {
            position: 'relative',
            overflow: 'hidden',
            border: !hideBorder ? `0.1rem solid ${theme.color.border.base}` : 'none',
            borderRadius: theme.spacing[100],
            aspectRatio: mobileAspectRatio,
            [theme.breakpoint.minWidth('md')]: {
                aspectRatio: desktopAspectRatio,
            },
        }, children: children }));
};
//# sourceMappingURL=AdContainerBox.js.map